import { getYearsList } from '@/views/mped/services/mped-estimate-service';
import { numberFormat, numberWidth } from '@/views/mped/services/mped-columns-service';

export function getPeriods(negYear = 10, posYear = 0) {
  const
    currentDate = new Date(),
    list = [];
  let current = '';
  let prev = '';

  getYearsList(currentDate.getFullYear(), negYear, posYear).forEach(year => {
      for (let m = 1; m <= 12; m++) {
        const month = m < 10 && `0${m}` || m;
        const period = `${year}.${month}`;
        list.push({ id: period });
        if (currentDate.getFullYear() === year && currentDate.getMonth() === m - 1) {
          current = period;
          prev = list[list.length - 2].id;
        }
      }
    },
  );

  return {
    current,
    prev,
    list,
  };
}

export const reportViewMods = [
  { id: 1, name: 'Нет видов деятельности', filter: 'kod_spr_vid_dey' },
  { id: 2, name: 'Нет МВП', filter: 'mvp_kod' },
  { id: 3, name: 'Нет кода фин.сист.', filter: 'kod_spr_smet_zatr' },
];

export const reportPages = [
  { id: 1, name: 'columnsCalculationSap', title: 'Загруженные данные' },
  { id: 2, name: 'columnsReportErrorList', title: 'Список' },
  { id: 3, name: 'columnsDoubleSap', title: 'Дубли перекод. статей' },
];

export function getCalculationReportColumns() {
  return [...columnsCalculationSap(true), ...columnsDoubleSap];
}

export const columnsCalculationSap = (report, lookupList, isEditable) => {
  const columns = [
    {
      dataField: 'kod_sp_calc',
      caption: 'ID',
      dataType: 'number',
      width: '100px',
      visible: false,
      alwaysVisible: false,
      allowEditing: false,
    }, {
      caption: 'Вид деятельности',
      viewArea: 1,
      viewMode: 'kod_spr_vid_dey',
      columns: [{
        dataField: 'vid_dey_kod',
        caption: 'Код',
        width: '90px',
        dataType: 'number',
        allowEditing: false,
      }, {
        dataField: 'vid_dey_name',
        caption: 'Наименование',
        width: '200px',
        allowEditing: false,
      }, {
        dataField: 'vid_energ_name',
        caption: 'Вид энергии',
        width: '120px',
        allowEditing: false,
      }, {
        dataField: 'od_nd_name',
        caption: 'ОД - НД',
        width: '100px',
        allowEditing: false,
      }],
    }, {
      caption: 'Объект генерации',
      viewArea: 1,
      columns: [{
        dataField: 'ob_gen_kod',
        caption: 'Код',
        width: '150px',
        allowEditing: false,
      }, {
        dataField: 'ob_gen_name',
        caption: 'Наименование',
        width: '200px',
        allowEditing: false,
      }],
    }, {
      dataField: 'period',
      caption: 'Период',
      width: '150px',
      allowEditing: false,
      viewArea: 1,
    }, {
      caption: 'Субъект РФ',
      viewArea: 1,
      columns: [{
        dataField: 'subject_fed_kod',
        caption: 'Код',
        width: '90px',
        dataType: 'number',
        allowEditing: true,
        cellTemplate: report || !isEditable ? null : 'editableCellTemplate',
        lookup: report || !isEditable? null : lookupList['countrySubjects'],
      }, {
        dataField: 'subject_fed_name',
        caption: 'Наименование',
        width: '150px',
        allowEditing: false,
      }],
    }, {
      caption: 'Заказ',
      viewArea: 1,
      columns: [{
        dataField: 'zakaz_kod',
        caption: 'Заказ',
        width: '120px',
        allowEditing: false,
      }, {
        dataField: 'zakaz_name',
        caption: 'Наименование',
        width: '200px',
        allowEditing: false,
      }],
    }, {
      caption: 'МВЗ',
      viewArea: 1,
      columns: [{
        dataField: 'mb3_kod',
        caption: 'Код',
        width: '120px',
        allowEditing: false
      }, {
        dataField: 'mb3_name',
        caption: 'Наименование',
        width: '200px',
        allowEditing: false
      }, {
        dataField: 'mb3_kod_account',
        caption: 'Код счета МВЗ',
        width: '90px',
        dataType: 'number',
        allowEditing: false,
      }],
    }, {
      caption: 'МВП: Партнёр',
      viewArea: 1,
      columns: [{
        dataField: 'mvp_partner_kod',
        caption: 'Код',
        width: '90px',
        allowEditing: false
      }, {
        dataField: 'mvp_partner_name',
        caption: 'Наименование',
        width: '200px',
        allowEditing: false
      }],
    }, {
      caption: 'Элемент затрат',
      viewArea: 1,
      viewMode: 'kod_spr_smet_zatr',
      columns: [{
        dataField: 'el_zatr_kod',
        caption: 'Код',
        width: '130px',
        allowEditing: true,
        cellTemplate: report || !isEditable ? null : 'editableCellTemplate',
      }, {
        dataField: 'el_zatr_name',
        caption: 'Наименование',
        width: '200px',
        allowEditing: false,
      }, {
        dataField: 'el_zatr_name_list',
        caption: 'Список статей сметы по коду фин.сист.',
        width: '200px',
        allowEditing: false,
      }],
    }, {
      caption: 'МВП',
      viewArea: 1,
      viewMode: 'mvp_kod',
      columns: [{
        dataField: 'mvp_kod',
        caption: 'Код',
        width: '90px',
        allowEditing: false
      }, {
        dataField: 'mvp_name',
        caption: 'Наименование',
        width: '200px',
        allowEditing: false
      }, {
        dataField: 'department_mdep',
        caption: 'Подразделение МПЕД',
        width: '200px',
        allowEditing: false,
      }],
    }, {
      isReport: true,
      caption: 'Тип данных бюджета',
      viewArea: 1,
      columns: [{
        dataField: 'budget_type_code',
        caption: 'Код',
        allowEditing: false,
      }, {
        dataField: 'budget_type_name',
        caption: 'Наименование',
        allowEditing: false,
      }],
    }, {
      dataField: 'vyruchka',
      caption: 'Выручка',
      width: '150px',
      format: numberFormat,
      summary: 'sum',
      allowEditing: false,
      viewArea: 1,
    }, {
      dataField: 'vol_sbyt',
      caption: 'Объем сбыта',
      width: '150px',
      format: numberFormat,
      summary: 'sum',
      allowEditing: false,
      viewArea: 1,
    }, {
      dataField: 'zatr',
      caption: 'Затраты',
      width: '150px',
      format: numberFormat,
      summary: 'sum',
      allowEditing: false,
      viewArea: 1,
    }, {
      dataField: 'tut',
      caption: 'ТУТ',
      width: '150px',
      format: numberFormat,
      summary: 'sum',
      allowEditing: false,
      viewArea: 1,
    }, {
      dataField: 'rash_vod_m3',
      caption: 'РасхВод М3',
      width: '150px',
      format: numberFormat,
      summary: 'sum',
      allowEditing: false,
      viewArea: 1,
    }, {
      dataField: 'rash_vod_t',
      caption: 'РасхВод Т',
      width: '150px',
      format: numberFormat,
      summary: 'sum',
      allowEditing: false,
      viewArea: 1,
    }, {
      dataField: 'rez_tepl_nag',
      caption: 'РезТеплНаг',
      width: '150px',
      format: numberFormat,
      summary: 'sum',
      allowEditing: false,
      viewArea: 1,
    }, {
      dataField: 'pris_tep_nag',
      caption: 'ПрисТепНаг',
      width: '150px',
      format: numberFormat,
      summary: 'sum',
      allowEditing: false,
      viewArea: 1,
    },
  ];

  const _columns = !report && columns.filter(col => !col.isReport) || columns;
  return JSON.parse(JSON.stringify(_columns));
};

const columnsDoubleSap = [
  {
    caption: 'Код фин.сист.',
    viewArea: 3,
    columns: [{
      dataField: 'sap_code',
      caption: 'Код',
      width: '90px',
    }, {
      dataField: 'period_s',
      caption: 'Период "С" привязки к статье сметы',
      width: '200px',
    }, {
      dataField: 'period_po',
      caption: 'Период "ПО" привязки к статье сметы',
      width: '200px',
    }],
  }, {
    caption: 'Статья сметы',
    viewArea: 3,
    columns: [{
      dataField: 'kod_smet',
      caption: 'Код',
      width: '90px',
    }, {
      dataField: 'name',
      caption: 'Наименование',
      width: '300px',
    }, {
      dataField: 'dat_start',
      caption: 'Дата "С"',
      width: '100px',
    }, {
      dataField: 'dat_finish',
      caption: 'Дата "ПО"',
      width: '100px',
    }, {
      dataField: 'root_code',
      caption: 'Признак',
      width: '100px',
    }],
  },
];


export const columnsUploadHistorySap = [
{
  dataField: 'kod_sp_zatr_load_log',
  caption: 'ID',
  dataType: 'number',
  width: '100px',
  visible: false,
}, {
  dataField: 'd_c',
  caption: 'Дата загрузки',
  dataType: 'datetime',
  width: '120px',
}, {
  dataField: 'direct_name',
  caption: 'Подразделение',
  dataType: 'string',
  width: '150px',
}, {
  dataField: 'period',
  caption: 'Периоды',
  dataType: 'string',
  width: '250px',
}, {
  dataField: 'filename',
  caption: 'Файл',
  dataType: 'string',
  width: '350px',
}, {
  dataField: 'rows_quantity',
  caption: 'Кол-во загруженных строк',
  dataType: 'number',
  width: '100px',
}, {
  dataField: 'u_m',
  caption: 'Пользователь',
  dataType: 'string',
  width: '200px',
}, {
  dataField: 't_m',
  caption: 'Терминал',
  dataType: 'string',
}];

export const columnsUploadHistoryAmortizationSap = [
  {
    dataField: 'id',
    caption: 'ID',
    dataType: 'number',
    width: '100px',
    visible: false,
  }, {
    dataField: 'started_at',
    caption: 'Дата загрузки',
    dataType: 'datetime',
    width: '120px',
  }, {
    dataField: 'department',
    caption: 'Подразделение',
    dataType: 'string',
    width: '150px',
  }, {
    dataField: 'period',
    caption: 'Периоды',
    dataType: 'string',
    width: '250px',
  }, {
    dataField: 'filename',
    caption: 'Файл',
    dataType: 'string',
    width: '350px',
    cellTemplate: 'templateFileName'
  }, {
    dataField: 'total_count',
    caption: 'Кол-во загруженных строк',
    dataType: 'number',
    width: '100px',
  }, {
    dataField: 'user',
    caption: 'Пользователь',
    dataType: 'string',
    width: '200px',
  }, {
    dataField: 'status',
    caption: 'Статус',
    dataType: 'string',
    width: '200px',
  }, {
    dataField: 'error_text',
    caption: 'Текст ошибки',
    dataType: 'string',
  }];

export const columnsCalculationReport = () => {
  const columns = [
    {
      dataField: 'ord',
      caption: 'ID',
      dataType: 'number',
      width: '100px',
      visible: false,
    }, {
      dataField: 'name',
      dataType: 'string',
      caption: 'Наименование',
      width: '200px',
      fixed: true,
    }, {
      dataField: 'teplo_ee',
      caption: 'Топливо э/э',
      width: '150px',
      format: numberFormat,
      viewId: [1, 3],
    }, {
      dataField: 'teplo_te',
      caption: 'Топливо т/э',
      width: '150px',
      format: numberFormat,
      viewId: [1, 3],
    }, {
      dataField: 'voda_ee',
      caption: 'Вода э/э',
      width: '150px',
      format: numberFormat,
      viewId: [1, 3],
    }, {
      dataField: 'voda_te',
      caption: 'Вода т/э',
      width: '150px',
      format: numberFormat,
      viewId: [1, 3],
    }, {
      dataField: 'opl_trud_ee',
      caption: 'Основная оплата труда  э/э',
      width: '150px',
      format: numberFormat,
      viewId: [1, 3],
    }, {
      dataField: 'opl_trud_te',
      caption: 'Основная оплата труда т/э',
      width: '150px',
      format: numberFormat,
      viewId: [1, 3],
    }, {
      dataField: 'soc_ee',
      caption: 'Отчисления на соц.нужды э/э',
      width: '150px',
      format: numberFormat,
      viewId: [1, 3],
    }, {
      dataField: 'soc_te',
      caption: 'Отчисления на соц.нужды т/э',
      width: '150px',
      format: numberFormat,
      viewId: [1, 3],
    }, {
      dataField: 'amort_ee',
      caption: 'Амортизация оборудования э/э',
      width: '150px',
      format: numberFormat,
      viewId: [1, 3],
    }, {
      dataField: 'amort_te',
      caption: 'Амортизация оборудования т/э',
      width: '150px',
      format: numberFormat,
      viewId: [1, 3],
    }, {
      dataField: 'sod_obor_ee',
      caption: 'Расходы по сод.обор. э/э',
      width: '150px',
      format: numberFormat,
      viewId: [1, 3],
    }, {
      dataField: 'sod_obor_te',
      caption: 'Расходы по сод.обор. т/э',
      width: '150px',
      format: numberFormat,
      viewId: [1, 3],
    }, {
      dataField: 'ceh_ee',
      caption: 'Цеховые расходы э/э',
      width: '150px',
      format: numberFormat,
      viewId: [1, 3],
    }, {
      dataField: 'ceh_te',
      caption: 'Цеховые расходы т/э',
      width: '150px',
      format: numberFormat,
      viewId: [1, 3],
    }, {
      dataField: 'zavod_ee',
      caption: 'Общезавод. расходы э/э',
      width: '150px',
      format: numberFormat,
      viewId: [1, 3],
    }, {
      dataField: 'zavod_te',
      caption: 'Общезавод. расходы т/э',
      width: '150px',
      format: numberFormat,
      viewId: [1, 3],
    }, {
      dataField: 'usl_ryn_ee',
      caption: 'Услуги рынка э/э',
      width: '150px',
      format: numberFormat,
      viewId: [1, 3],
    }, {
      dataField: 'pokup_ee_ee',
      caption: 'Покупная э/э',
      width: '150px',
      format: numberFormat,
      viewId: [1],
      separate: true,
    }, {
      dataField: 'pokup_ee_ee',
      caption: 'Покупная э/э на э/э',
      width: '150px',
      format: numberFormat,
      viewId: [3],
      visible: false,
      showInColumnChooser: false
    }, {
      dataField: 'pokup_ee_te',
      caption: 'Покупная э/э на т/э',
      width: '150px',
      format: numberFormat,
      viewId: [3],
      visible: false,
      showInColumnChooser: false
    }, {
      dataField: 'pokup_te',
      caption: 'Покупная т/э',
      width: '150px',
      format: numberFormat,
      viewId: [1, 3],
    }, {
      dataField: 'total_ee',
      caption: 'Всего затрат э/э',
      width: '150px',
      format: numberFormat,
      viewId: [1, 3],
    }, {
      dataField: 'total_te',
      caption: 'Всего затрат т/э',
      width: '150px',
      format: numberFormat,
      viewId: [1, 3],
    }, {
      dataField: 'total',
      caption: 'ИТОГО',
      width: '150px',
      format: numberFormat,
      viewId: [1, 3],
    }, {
      dataField: 'vod_tax',
      dataType: 'number',
      caption: 'Водный налог (6.2.) э/э',
      width: '150px',
      format: numberFormat,
      viewId: [2],
      visible: false,
      showInColumnChooser: false,
    }, {
      dataField: 'vod_tax_te',
      dataType: 'number',
      caption: 'Водный налог (6.2.) э/э',
      width: '150px',
      format: numberFormat,
      viewId: [2],
      visible: false,
      showInColumnChooser: false,
    }, {
      dataField: 'en_hoz_ee',
      dataType: 'number',
      caption: 'Водный налог (6.2.) э/э',
      width: '150px',
      format: numberFormat,
      viewId: [2],
      visible: false,
      showInColumnChooser: false,
    }, {
      dataField: 'en_hoz_te',
      dataType: 'number',
      caption: 'Энергия на хоз.нужды т/э',
      width: '150px',
      format: numberFormat,
      viewId: [2],
      visible: false,
      showInColumnChooser: false,
    }, {
      dataField: 'tax_ee',
      dataType: 'number',
      caption: 'Налоги (18) э/э',
      width: '150px',
      format: numberFormat,
      viewId: [2],
      visible: false,
      showInColumnChooser: false,
    }, {
      dataField: 'tax_te',
      dataType: 'number',
      caption: 'Налоги (18) т/э',
      width: '150px',
      format: numberFormat,
      viewId: [2],
      visible: false,
      showInColumnChooser: false,
    }, {
      dataField: 'remont_ee',
      dataType: 'number',
      caption: 'Ремонт э/э',
      width: '150px',
      format: numberFormat,
      viewId: [2],
      visible: false,
      showInColumnChooser: false,
    }, {
      dataField: 'remont_te',
      dataType: 'number',
      caption: 'Ремонт т/э',
      width: '150px',
      format: numberFormat,
      viewId: [2],
      visible: false,
      showInColumnChooser: false,
    }, {
      dataField: '',
      caption: '',
      viewId: [2],
      visible: false,
      minWidth: 0,
      showInColumnChooser: false,
      allowEditing: false,
    },
  ];

  return JSON.parse(JSON.stringify(columns));
};

export const totalReportPages = [
  { id: 1, name: 'calculationKaf', title: 'Ф1', viewId: 1 },
  { id: 2, name: 'calculationKf', title: 'Ф2', viewId: 3 },
  { id: 3, name: 'calculationNf', title: 'Ф3', viewId: 1 },
  { id: 4, name: 'calculationNfLo', title: 'Ф3(обл)', viewId: 1 },
  { id: 5, name: 'calculationNfSpb', title: 'Ф3(гор)', viewId: 1 },
  { id: 6, name: 'calculationTgk', title: 'Предприятие', viewId: 3 },
  { id: 7, name: 'calculationRef', title: 'Справка', viewId: 2 },
];


export const getColumns = (view) => {
  let columns;
  switch (view) {
    case 'article':
      columns = columnsCalculationArticle;
      break;
  }

  return JSON.parse(JSON.stringify(columns));
};

const columnsCalculationArticle = [{
  dataField: 'id',
  caption: 'ID',
  dataType: 'number',
  width: '100px',
  visible: false,
}, {
  dataField: 'name',
  caption: 'Статья затрат для калькуляции',
  dataType: 'string',
  fixed: true,
  width: '200px',
},
  {
    dataField: 'main_production',
    caption: 'Основ. пр.',
    columns: [
      {
        dataField: 'total_op',
        dataType: 'number',
        caption: '',
        width: numberWidth,
        format: numberFormat,
        headerCellTemplate: 'headerCellTemplate',
      }, {
        dataField: 'ee_op',
        dataType: 'number',
        caption: 'э/э',
        width: numberWidth,
        format: numberFormat,
        visible: true,
      }, {
        dataField: 'te_op',
        dataType: 'number',
        caption: 'т/э',
        width: numberWidth,
        format: numberFormat,
        visible: true,
      },
    ],
  },
  {
    dataField: 'help_production',
    caption: 'Вспомогат. пр.',
    columns: [
      {
        dataField: 'total_vp',
        dataType: 'number',
        caption: '',
        width: numberWidth,
        format: numberFormat,
        headerCellTemplate: 'headerCellTemplate',
      }, {
        dataField: 'ee_vp',
        dataType: 'number',
        caption: 'э/э',
        width: numberWidth,
        format: numberFormat,
        visible: true,
      }, {
        dataField: 'te_vp',
        dataType: 'number',
        caption: 'т/э',
        width: numberWidth,
        format: numberFormat,
        visible: true,
      },
    ],
  },
  {
    dataField: 'opr_production',
    caption: 'ОПР',
    columns: [
      {
        dataField: 'total_opr',
        dataType: 'number',
        caption: '',
        width: numberWidth,
        format: numberFormat,
        headerCellTemplate: 'headerCellTemplate',
      }, {
        dataField: 'ee_opr',
        dataType: 'number',
        caption: 'э/э',
        width: numberWidth,
        format: numberFormat,
        visible: true,
      }, {
        dataField: 'te_opr',
        dataType: 'number',
        caption: 'т/э',
        width: numberWidth,
        format: numberFormat,
        visible: true,
      },
    ],
  },
  {
    dataField: 'main_production',
    caption: 'ОХР',
    columns: [
      {
        dataField: 'total_ohr',
        dataType: 'number',
        caption: '',
        width: numberWidth,
        format: numberFormat,
        headerCellTemplate: 'headerCellTemplate',
      }, {
        dataField: 'ee_ohr',
        dataType: 'number',
        caption: 'э/э',
        width: numberWidth,
        format: numberFormat,
        visible: true,
      }, {
        dataField: 'te_ohr',
        dataType: 'number',
        caption: 'т/э',
        width: numberWidth,
        format: numberFormat,
        visible: true,
      },
    ],
  },
  {
    dataField: 'total',
    dataType: 'number',
    caption: 'Общий итог',
    width: numberWidth,
    format: numberFormat,
  },
  {
    minWidth: 0,
  },
];

export const columnsAmortizationMainAsset = [
  {
    dataField: 'id',
    caption: 'ID',
    dataType: 'number',
    width: '100px',
    visible: false,
  }, {
    dataField: 'department_id',
    caption: 'ID подразделения',
    dataType: 'number',
    width: '100px',
    visible: false,
  }, {
    dataField: 'department',
    caption: 'Подразделение',
    dataType: 'string',
    width: '200px',
  }, {
    dataField: 'inventory_number',
    caption: 'Инвентарный номер',
    dataType: 'string',
    width: '250px',
  }, {
    dataField: 'main_asset',
    caption: 'Основное средство',
    dataType: 'string',
    width: '150px',
  }, {
    dataField: 'class_main_asset',
    caption: 'Класс ОC',
    dataType: 'number',
    width: '150px',
  }, {
    dataField: 'subnumber',
    caption: 'Субномер',
    dataType: 'number',
    width: '150px'
  }, {
    dataField: 'name',
    caption: 'Название',
    dataType: 'string',
    width: '250px'
  }, {
    dataField: 'mvz',
    caption: 'МВЗ',
    dataType: 'string',
    width: '150px'
  }, {
    dataField: 'internal_order',
    caption: 'Внутренний заказ',
    dataType: 'string',
    width: '150px'
  }, {
    dataField: 'group_amortization',
    caption: 'Группа амортизации',
    dataType: 'number',
    width: '150px',
  }, {
    dataField: 'date_receipts',
    caption: 'Дата оприходования',
    dataType: 'date',
    width: '150px',
  }, {
    dataField: 'useful_life',
    caption: 'Срок полезного использования по бух.учету',
    dataType: 'number',
    width: '150px',
  }, {
    dataField: 'useful_life_tarif',
    caption: 'Срок полезного использования по тариф. рег.',
    dataType: 'number',
    width: '150px',
  }, {
    dataField: 'created_at',
    caption: 'Дата создания',
    dataType: 'datetime',
    width: '150px',
  }, {
    dataField: 'updated_at',
    caption: 'Дата изменения',
    dataType: 'datetime',
    width: '150px',
  }];

export const columnsAmortizationUploadView = [
  {
    dataField: 'id',
    caption: 'ID',
    dataType: 'number',
    width: '100px',
    visible: false,
  }, {
    dataField: 'main_asset_id',
    caption: 'ID ОС',
    dataType: 'number',
    width: '100px',
    visible: false,
  }, {
    dataField: 'period_str',
    caption: 'Период',
    dataType: 'string',
    width: '100px'
  },{
    dataField: 'mvp',
    caption: 'МВП',
    dataType: 'string',
    width: '50px',
  }, {
    dataField: 'name_factory',
    caption: 'Наименование завода',
    dataType: 'string',
    width: '200px',
  }, {
    dataField: 'inventory_number',
    caption: 'Инвентарный номер',
    dataType: 'string',
    width: '150px',
  }, {
    dataField: 'main_asset',
    caption: 'Основное средство',
    dataType: 'string',
    width: '120px',
  }, {
    dataField: 'class_main_asset',
    caption: 'Класс ОC',
    dataType: 'number',
    width: '80px',
  }, {
    dataField: 'subnumber',
    caption: 'Субномер',
    dataType: 'number',
    width: '50px'
  }, {
    dataField: 'name',
    caption: 'Название',
    dataType: 'string',
    width: '250px'
  }, {
    dataField: 'addition_name',
    caption: 'Название/продолжение',
    dataType: 'string',
    width: '250px'
  }, {
    dataField: 'date_receipts',
    caption: 'Дата оприходования',
    dataType: 'date',
    width: '100px',
  }, {
    dataField: 'date_write_of',
    caption: 'Дата списания',
    dataType: 'date',
    width: '100px',
  }, {
    dataField: 'group_amortization',
    caption: 'Группа амортизации',
    dataType: 'number',
    width: '150px',
  }, {
    dataField: 'code_okof',
    caption: 'Код ОКОФ',
    dataType: 'string',
    width: '150px',
  }, {
    dataField: 'mvz',
    caption: 'МВЗ',
    dataType: 'string',
    width: '150px',
  }, {
    dataField: 'internal_order',
    caption: 'Внутренний заказ',
    dataType: 'string',
    width: '150px',
  }, {
    dataField: 'useful_life',
    caption: 'Срок полезного использования',
    dataType: 'number',
    width: '150px',
  }, {
    dataField: 'cost_begin',
    caption: 'Первоначальная стоимость на начало пер.',
    dataType: 'number',
    width: '150px',
    format: numberFormat,
  }, {
    dataField: 'change_cost_begin',
    caption: 'Измен. первонач. стоимости за период',
    dataType: 'number',
    width: '150px',
    format: numberFormat,
  }, {
    dataField: 'receipt_period',
    caption: 'Поступление за период',
    dataType: 'number',
    width: '150px',
    format: numberFormat,
  }, {
    dataField: 'purchase',
    caption: 'Покупка',
    dataType: 'number',
    width: '150px',
    format: numberFormat,
  }, {
    dataField: 'modernization',
    caption: 'Модернизация',
    dataType: 'number',
    width: '150px',
    format: numberFormat,
  }, {
    dataField: 'date_receipt_posting',
    caption: 'Дата проводки поступления',
    dataType: 'date',
    width: '120px'
  }, {
    dataField: 'receipt_other',
    caption: 'Поступление прочее',
    dataType: 'number',
    width: '150px',
    format: numberFormat,
  }, {
    dataField: 'disposal_period',
    caption: 'Выбытие за период',
    dataType: 'number',
    width: '150px',
    format: numberFormat,
  }, {
    dataField: 'cost_end',
    caption: 'Первоначальная стоимость на конец пер.',
    dataType: 'number',
    width: '150px',
    format: numberFormat,
  }, {
    dataField: 'amortization_type_begin',
    caption: 'Аморт. типов. на начало периода',
    dataType: 'number',
    width: '150px',
    format: numberFormat,
  }, {
    dataField: 'amortization_period',
    caption: 'Аморт. типовая начисл. за период',
    dataType: 'number',
    width: '150px',
    format: numberFormat,
  }, {
    dataField: 'change_amortization_type',
    caption: 'Изменение типовой амортизации за период',
    dataType: 'number',
    width: '150px',
    format: numberFormat,
  }, {
    dataField: 'amortization_type_end',
    caption: 'Аморт. типовая на конец периода',
    dataType: 'number',
    width: '150px',
    format: numberFormat,
  }, {
    dataField: 'residual_value_begin',
    caption: 'Остаточная стоимость на начало периода',
    dataType: 'number',
    width: '150px',
    format: numberFormat,
  }, {
    dataField: 'residual_value_end',
    caption: 'Остаточная стоимость на конец периода',
    dataType: 'number',
    width: '150px',
    format: numberFormat,
  }, {
    dataField: 'remaining_term',
    caption: 'Оставшийся срок ПолезИспол с нач.аморт',
    dataType: 'number',
    width: '150px'
  },
  {
    dataField: 'created_at',
    caption: 'Дата создания',
    dataType: 'datetime',
    width: '150px',
  }, {
    dataField: 'updated_at',
    caption: 'Дата изменения',
    dataType: 'datetime',
    width: '150px',
  }];
